import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';
import { mediaQuery } from '../../../utils/styles';

export const OfferCardListingSkeletonContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: ${toRem(1124)};
  padding-top: ${toRem(44)};
  padding-bottom: ${toRem(64)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media ${mediaQuery.tabletMax} {
    max-width: ${toRem(704)};
  }

  @media ${mediaQuery.mobileOnly} {
    max-width: ${toRem(332)};
    padding: ${toRem(24)} ${toRem(33)} ${toRem(64)};
  }

  .heading {
    width: 45%;
    height: ${toRem(44)};
    border-radius: ${toRem(20)};
    @media ${mediaQuery.tabletMax} {
      width: 50%;
      height: ${toRem(44)};
      margin-bottom: ${toRem(50)};
    }
    @media ${mediaQuery.mobileOnly} {
      width: 70%;
      height: ${toRem(44)};
      margin-bottom: ${toRem(30)};
    }
  }

  .card {
    display: flex;
    flex-direction: row;
    width: 100%;
    margin: ${toRem(64)} ${toRem(16)} 0;
    border-radius: ${toRem(14)};
    overflow: hidden;
    .card-content {
      flex: 0 0 40%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 3.9375rem 3.5rem 5.4375rem;
      .card-heading {
        width: 100%;
        height: ${toRem(30)};
        margin-bottom: ${toRem(16)};
      }
      .card-p {
        width: 100%;
        height: 14px;
        margin-bottom: ${toRem(8)};
      }
      .card-button {
        width: 40%;
        height: ${toRem(40)};
        border-radius: ${toRem(52)};
        margin-top: ${toRem(18)};
        @media ${mediaQuery.mobileOnly} {
          width: 70%;
          height: ${toRem(30)};
        }
      }
      @media ${mediaQuery.mobileOnly} {
        flex: 0 0 auto; // Changed from 100% to auto
      }
    }
    .card-image {
      width: 100%;
      height: ${toRem(360)};
      flex: 0 0 60%;
      @media ${mediaQuery.mobileOnly} {
        width: 100%;
        height: ${toRem(150)} !important;
        flex: none; // Remove flex property in mobile
        order: -1; // Optional: Move image to top in mobile view
        border-top-left-radius: ${toRem(14)};
        border-top-right-radius: ${toRem(14)};
      }
    }
    @media ${mediaQuery.mobileOnly} {
      flex-direction: column;
      margin: ${toRem(32)} ${toRem(16)} 0; // Reduced top margin for mobile
      width: 100%; // Allow card to size based on content
      max-width: 100%; // Prevent overflow
    }
  }

  .button {
    height: ${toRem(40)};
    width: ${toRem(140)};
    border-radius: ${toRem(20)};
    margin-top: ${toRem(64)};
    @media ${mediaQuery.mobileOnly} {
      width: ${toRem(120)};
      margin-top: ${toRem(32)};
    }
  }
`;
